module.exports = __webpack_public_path__ + "src/assets/img/hxjs_hxjs_01@2x.96743dc2.png";